/**
 * Luxury Quick View Modal Engine - Vastradevi Theme
 */
(function () {
  'use strict';

  var currentProduct = null;
  var currentVariant = null;
  var currentImages = [];
  var currentImageIndex = 0;

  // Moves the main image to a given index (wrapping around), keeping the
  // thumbnail strip's active state in sync — shared by the thumbnail clicks
  // and the hover-only prev/next arrows.
  function goToImage(idx) {
    if (!currentImages.length) return;
    currentImageIndex = ((idx % currentImages.length) + currentImages.length) % currentImages.length;
    var els = getElements();
    if (els.mainImg) els.mainImg.src = currentImages[currentImageIndex];
    if (els.thumbnails) {
      els.thumbnails.querySelectorAll('.quickview-thumb-btn').forEach(function (b, i) {
        b.classList.toggle('active', i === currentImageIndex);
      });
    }
  }

  // Deterministic per-product "low stock" count, mirroring the Liquid
  // formula in snippets/generated-stock-urgency.liquid so the number shown
  // in Quick View always matches the full product page for the same
  // product/day (stable per product per day, not random per render).
  function computeStockUrgency(product) {
    var createdMs = new Date(product.created_at).getTime() || Date.now();
    var daysSince = Math.max(0, Math.floor((Date.now() - createdMs) / 86400000));
    var stockBase = (product.id % 10) + 6;
    var stockDecay = Math.floor(daysSince / 5);
    return Math.max(stockBase - stockDecay, 3);
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    // Matches this theme's `| money` filter output exactly (used on the
    // product detail page) — "₹ X,XXX.XX", with a space after the symbol.
    var amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '₹ ' + amount;
  }

  // Same "charm pricing" rule as round-price-charm.liquid: round to the
  // nearest whole-rupee price ending in 9, e.g. 4048.5 -> 4049.
  function roundToCharm9(rupees) {
    rupees = Math.round(rupees);
    var lower9 = Math.floor((rupees - 9) / 10) * 10 + 9;
    var upper9 = lower9 + 10;
    var result = (rupees - lower9 <= upper9 - rupees) ? lower9 : upper9;
    return Math.max(9, result);
  }

  function getElements() {
    return {
      modal: document.getElementById('QuickViewModal'),
      overlay: document.getElementById('QuickViewOverlay'),
      closeBtn: document.getElementById('QuickViewClose'),
      dragHandle: document.getElementById('QuickViewDragHandle'),
      dialog: document.querySelector('#QuickViewModal .quickview-dialog'),
      spinner: document.getElementById('QuickViewSpinner'),
      body: document.getElementById('QuickViewBody'),
      vendor: document.getElementById('QuickViewVendor'),
      title: document.getElementById('QuickViewTitle'),
      priceActive: document.getElementById('QuickViewPrice'),
      priceCompare: document.getElementById('QuickViewComparePrice'),
      discountBadge: document.getElementById('QuickViewDiscount'),
      badgeSale: document.getElementById('QuickViewBadge'),
      description: document.getElementById('QuickViewDescription'),
      stockUrgency: document.getElementById('QuickViewStockUrgency'),
      stockCount: document.getElementById('QuickViewStockCount'),
      mainImg: document.getElementById('QuickViewMainImg'),
      mainImageWrap: document.querySelector('.quickview-main-image-wrap'),
      imagePrev: document.getElementById('QuickViewImagePrev'),
      imageNext: document.getElementById('QuickViewImageNext'),
      thumbnails: document.getElementById('QuickViewThumbnails'),
      optionsContainer: document.getElementById('QuickViewOptions'),
      swatchesContainer: document.getElementById('QuickViewSwatches'),
      activeColor: document.getElementById('QuickViewActiveColor'),
      form: document.getElementById('QuickViewForm'),
      variantInput: document.getElementById('QuickViewVariantId'),
      qtyInput: document.getElementById('QuickViewQty'),
      qtyMinus: document.getElementById('QuickViewQtyMinus'),
      qtyPlus: document.getElementById('QuickViewQtyPlus'),
      addToCartBtn: document.getElementById('QuickViewAddToCart'),
      buyNowWrap: document.getElementById('QuickViewBuyNowWrap'),
      wishlistBtn: document.getElementById('QuickViewWishlist'),
      fullDetailsLink: document.getElementById('QuickViewFullDetails')
    };
  }

  function openModal(handle) {
    var els = getElements();
    if (!els.modal) return;

    els.modal.classList.add('is-open');
    els.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Show spinner loader, clear previous values
    if (els.spinner) els.spinner.style.display = 'flex';
    if (els.body) els.body.style.opacity = '0.3';
    if (els.title) els.title.textContent = 'Loading...';
    if (els.qtyInput) els.qtyInput.value = '1';
    if (els.buyNowWrap) els.buyNowWrap.innerHTML = '';

    // Fetch product details from Shopify native JSON endpoint
    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(function (product) {
        renderProduct(product);
      })
      .catch(function (err) {
        console.error('QuickView Error:', err);
        if (els.title) els.title.textContent = 'Unable to load product details.';
      })
      .finally(function () {
        if (els.spinner) els.spinner.style.display = 'none';
        if (els.body) els.body.style.opacity = '1';
      });

    // Fetch the SAME native Razorpay dynamic checkout button the real
    // product page uses (see templates/product.quickview-buy-now.liquid) -
    // {{ form | payment_button }} can only be server-rendered for one
    // specific product, so this is fetched per product instead of trying
    // to reuse/update a single static button for whichever product is open.
    if (els.buyNowWrap) {
      fetch('/products/' + handle + '?view=quickview-buy-now')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) { els.buyNowWrap.innerHTML = html; })
        .catch(function () { els.buyNowWrap.innerHTML = ''; });
    }
  }

  function closeModal() {
    var els = getElements();
    if (!els.modal) return;
    els.modal.classList.remove('is-open');
    els.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderProduct(product) {
    currentProduct = product;
    var els = getElements();

    // Vendor / Subtitle
    if (els.vendor) {
      els.vendor.textContent = product.vendor ? product.vendor.toUpperCase() : 'VASTRADEVI HANDLOOMS';
    }

    // Title
    if (els.title) {
      els.title.textContent = product.title;
    }

    // Full Details URL
    if (els.fullDetailsLink) {
      els.fullDetailsLink.href = '/products/' + product.handle;
    }

    // Wishlist button targets this product; re-sync its active state
    if (els.wishlistBtn) {
      els.wishlistBtn.setAttribute('data-wishlist-handle', product.handle);
      if (window.VDWishlist) window.VDWishlist.refresh();
    }

    // Main Image, Prev/Next Arrows & Thumbnails
    currentImages = (product.images && product.images.length) ? product.images.slice(0, 6) : (product.featured_image ? [product.featured_image] : []);
    currentImageIndex = 0;

    if (els.mainImg) {
      els.mainImg.src = currentImages[0] || product.featured_image || '';
      els.mainImg.alt = product.title;
    }

    var showImageNav = currentImages.length > 1;
    if (els.imagePrev) els.imagePrev.style.display = showImageNav ? '' : 'none';
    if (els.imageNext) els.imageNext.style.display = showImageNav ? '' : 'none';

    if (els.thumbnails) {
      els.thumbnails.innerHTML = '';
      if (currentImages.length > 1) {
        currentImages.forEach(function (imgSrc, idx) {
          var thumbBtn = document.createElement('button');
          thumbBtn.type = 'button';
          thumbBtn.className = 'quickview-thumb-btn' + (idx === 0 ? ' active' : '');
          thumbBtn.setAttribute('aria-label', 'View image ' + (idx + 1));

          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = product.title;
          thumbBtn.appendChild(img);

          thumbBtn.addEventListener('click', function () {
            goToImage(idx);
          });

          els.thumbnails.appendChild(thumbBtn);
        });
      }
    }

    // Low stock urgency badge
    if (els.stockUrgency && els.stockCount) {
      els.stockCount.textContent = computeStockUrgency(product);
      els.stockUrgency.style.display = '';
    }

    // Description Snippet (Strip HTML tags)
    if (els.description) {
      var tmp = document.createElement('div');
      tmp.innerHTML = product.description || '';
      var cleanText = tmp.textContent || tmp.innerText || '';
      els.description.textContent = cleanText.length > 180 ? cleanText.substring(0, 180) + '...' : cleanText;
    }

    // Colour options (variant-based), if the product has a colour option
    renderColorOptions(product);

    // Default to first variant
    currentVariant = product.variants ? product.variants[0] : null;
    updateVariantState(currentVariant);
    setActiveColorLabel(currentVariant);
  }

  // Finds the index (0-based) of a Color/Colour option, or -1 if none.
  function getColorOptionIndex(product) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var name = (typeof options[i] === 'string' ? options[i] : options[i].name) || '';
      if (name.toLowerCase().indexOf('color') !== -1 || name.toLowerCase().indexOf('colour') !== -1) {
        return i;
      }
    }
    return -1;
  }

  function colorOfVariant(variant, index) {
    return variant['option' + (index + 1)];
  }

  function setActiveColorLabel(variant) {
    var els = getElements();
    if (!els.activeColor || !currentProduct) return;
    var idx = getColorOptionIndex(currentProduct);
    if (idx === -1 || !variant) return;
    els.activeColor.textContent = colorOfVariant(variant, idx) || '';
  }

  function renderColorOptions(product) {
    var els = getElements();
    if (!els.optionsContainer || !els.swatchesContainer) return;

    var idx = getColorOptionIndex(product);
    var variants = product.variants || [];
    if (idx === -1 || variants.length < 2) {
      els.optionsContainer.style.display = 'none';
      els.swatchesContainer.innerHTML = '';
      return;
    }

    // One swatch per distinct colour value, using the first matching variant's image
    var seen = {};
    els.swatchesContainer.innerHTML = '';
    variants.forEach(function (variant) {
      var value = colorOfVariant(variant, idx);
      if (!value || seen[value]) return;
      seen[value] = true;

      var img = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'swatch-btn';
      btn.setAttribute('data-color', value);
      btn.title = value;
      btn.innerHTML = '<img src="' + img + '" alt="' + value.replace(/"/g, '') + '" width="28" height="28">';

      btn.addEventListener('click', function () {
        els.swatchesContainer.querySelectorAll('.swatch-btn').forEach(function (s) { s.classList.remove('active'); });
        btn.classList.add('active');
        // Select the first available variant of this colour (fall back to first match)
        var match = variants.filter(function (v) { return colorOfVariant(v, idx) === value; });
        var chosen = match.filter(function (v) { return v.available; })[0] || match[0];
        if (chosen) {
          currentVariant = chosen;
          updateVariantState(chosen);
          setActiveColorLabel(chosen);
          if (els.mainImg && img) els.mainImg.src = img;
        }
      });

      els.swatchesContainer.appendChild(btn);
    });

    // Mark the first variant's colour active
    var firstColor = colorOfVariant(variants[0], idx);
    var firstBtn = els.swatchesContainer.querySelector('[data-color="' + (firstColor || '').replace(/"/g, '') + '"]');
    if (firstBtn) firstBtn.classList.add('active');

    els.optionsContainer.style.display = '';
  }

  function updateVariantState(variant) {
    var els = getElements();
    if (!variant) return;

    if (els.variantInput) {
      els.variantInput.value = variant.id;
    }

    // Update Price display. Every product shows a sale price here (matching
    // the rest of the site): a real compare_at_price when the merchant set
    // one, otherwise a computed price * 1.5 "was" price rounded to a
    // charming ...9 whole rupee so it never shows a stray paise value.
    if (els.priceActive) {
      els.priceActive.textContent = formatMoney(variant.price);
      els.priceActive.setAttribute('data-money', variant.price);
    }

    var compareAtCents;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareAtCents = variant.compare_at_price;
    } else {
      compareAtCents = roundToCharm9((variant.price / 100) * 1.5) * 100;
    }

    if (els.priceCompare) {
      els.priceCompare.textContent = formatMoney(compareAtCents);
      els.priceCompare.setAttribute('data-money', compareAtCents);
      els.priceCompare.style.display = 'inline-block';
    }
    var discountPercent = Math.round(((compareAtCents - variant.price) * 100) / compareAtCents);
    if (els.discountBadge) {
      els.discountBadge.textContent = discountPercent + '% off';
      els.discountBadge.style.display = 'inline-block';
    }
    if (els.badgeSale) els.badgeSale.style.display = 'inline-block';

    // Update Add to Cart Button state
    if (els.addToCartBtn) {
      if (variant.available) {
        els.addToCartBtn.disabled = false;
        els.addToCartBtn.textContent = 'ADD TO CART';
        els.addToCartBtn.classList.remove('sold-out');
      } else {
        els.addToCartBtn.disabled = true;
        els.addToCartBtn.textContent = 'SOLD OUT';
        els.addToCartBtn.classList.add('sold-out');
      }
    }
  }


  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function initListeners() {
    var els = getElements();

    // Open Quick View listener
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quickview-handle]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-quickview-handle');
        if (handle) openModal(handle);
      }
    });

    // Close Modal listeners
    if (els.closeBtn) {
      els.closeBtn.addEventListener('click', closeModal);
    }

    if (els.overlay) {
      els.overlay.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // Main image prev/next arrows (only visible on hover, via CSS)
    if (els.imagePrev) {
      els.imagePrev.addEventListener('click', function (e) {
        e.stopPropagation();
        goToImage(currentImageIndex - 1);
      });
    }
    if (els.imageNext) {
      els.imageNext.addEventListener('click', function (e) {
        e.stopPropagation();
        goToImage(currentImageIndex + 1);
      });
    }

    // Mobile: swipe left/right on the main image to change it (arrows are
    // hover-only and hidden on mobile via CSS).
    if (els.mainImageWrap) {
      var imgTouchStartX = 0;
      var imgTouchStartY = 0;
      var IMG_SWIPE_THRESHOLD = 40;

      els.mainImageWrap.addEventListener('touchstart', function (e) {
        imgTouchStartX = e.touches[0].clientX;
        imgTouchStartY = e.touches[0].clientY;
      }, { passive: true });

      els.mainImageWrap.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - imgTouchStartX;
        var dy = e.changedTouches[0].clientY - imgTouchStartY;
        // Ignore mostly-vertical swipes so the sheet can still scroll
        if (Math.abs(dx) < IMG_SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
        goToImage(currentImageIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // Mobile bottom sheet: drag the notch down to close. Only the handle
    // itself starts the drag (pointer capture lets the finger keep dragging
    // even once it moves off the small notch); everything else in the
    // sheet — image, swatches, description — scrolls/behaves normally.
    if (els.dragHandle && els.dialog) {
      var dragStartY = 0;
      var dragDeltaY = 0;
      var dragging = false;
      var CLOSE_THRESHOLD = 90;

      function onDragMove(e) {
        if (!dragging) return;
        dragDeltaY = Math.max(0, e.clientY - dragStartY);
        els.dialog.style.transform = 'translateY(' + dragDeltaY + 'px)';
      }

      function onDragEnd(e) {
        if (!dragging) return;
        dragging = false;
        els.dialog.classList.remove('is-dragging');
        els.dragHandle.removeEventListener('pointermove', onDragMove);
        els.dragHandle.removeEventListener('pointerup', onDragEnd);
        els.dragHandle.removeEventListener('pointercancel', onDragEnd);

        var shouldClose = dragDeltaY > CLOSE_THRESHOLD;
        els.dialog.style.transform = '';
        if (shouldClose) closeModal();
      }

      els.dragHandle.addEventListener('pointerdown', function (e) {
        dragging = true;
        dragStartY = e.clientY;
        dragDeltaY = 0;
        els.dialog.classList.add('is-dragging');
        els.dragHandle.setPointerCapture(e.pointerId);
        els.dragHandle.addEventListener('pointermove', onDragMove);
        els.dragHandle.addEventListener('pointerup', onDragEnd);
        els.dragHandle.addEventListener('pointercancel', onDragEnd);
      });
    }

    // Quantity selectors
    if (els.qtyMinus) {
      els.qtyMinus.addEventListener('click', function () {
        var current = parseInt(els.qtyInput.value, 10) || 1;
        if (current > 1) els.qtyInput.value = current - 1;
      });
    }

    if (els.qtyPlus) {
      els.qtyPlus.addEventListener('click', function () {
        var current = parseInt(els.qtyInput.value, 10) || 1;
        els.qtyInput.value = current + 1;
      });
    }

    // Form submission via AJAX /cart/add.js
    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = els.variantInput ? els.variantInput.value : null;
        var qty = els.qtyInput ? parseInt(els.qtyInput.value, 10) : 1;

        if (!variantId) return;

        var originalBtnText = els.addToCartBtn.textContent;
        els.addToCartBtn.disabled = true;
        els.addToCartBtn.textContent = 'ADDING...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: qty
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            els.addToCartBtn.textContent = '✓ ADDED TO CART';
            els.addToCartBtn.classList.add('added-success');
            if (window.VDCartDrawer) {
              window.VDCartDrawer.refresh().then(function () {
                closeModal();
                window.VDCartDrawer.open();
              });
            } else {
              updateHeaderCartCount();
            }
            setTimeout(function () {
              els.addToCartBtn.disabled = false;
              els.addToCartBtn.textContent = originalBtnText;
              els.addToCartBtn.classList.remove('added-success');
            }, 2000);
          })
          .catch(function (err) {
            console.error('Add to Cart error:', err);
            els.addToCartBtn.disabled = false;
            els.addToCartBtn.textContent = 'ERROR - TRY AGAIN';
            setTimeout(function () {
              els.addToCartBtn.textContent = originalBtnText;
            }, 2000);
          });
      });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initListeners);
  } else {
    initListeners();
  }
})();
